import React from "react";
import "./_page-8.scss";
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";

export default function Page8() {
    const name = "page8";

    const {data, setData, showDetailModel} = useVMStore();

    const data4 = data["page4"];

    const value = [
        {
            label: "Standard",
            val: "Standard",
            imgSrc: process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/standard_gel.webp",
            imgSrc2D: process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/standard_gel_2D.png",
        },
        {
            label: "Premium",
            val: "Premium",
            imgSrc: process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/premium_gel.webp",
            imgSrc2D: process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/premium_gel_2D.png",
        },
    ];

    return (
        <Form className="page-8 d-flex justify-content-around flex-column flex-md-row">
            {value.map((v) => (
                <Form.Group
                    className="d-flex flex-column align-items-center pb-3 pb-md-0 col-12 col-md-6"
                    key={"page_8_op" + v.val}
                    controlId={"page_8_op_" + v.label}
                >
                    <label onClick={() => showDetailModel(v.imgSrc)}>
                        <img className="expand-btn" src={process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/expand.svg"} alt="expand" />
                        {data4 !== "2D" ? <img className="m-3" src={v.imgSrc} alt="" /> : ""}
                        <img src={v.imgSrc2D} alt={v.val} />
                    </label>
                    <Form.Check
                        type="radio"
                        className="mt-3"
                        label={v.label}
                        value={v.val}
                        checked={data[name] === v.val}
                        onChange={(e) => {
                            setData(e.target.value, "page8");
                        }}
                    />
                </Form.Group>
            ))}
        </Form>
    );
}
